import { useEffect, useState } from "react";

import logo390 from "./logo/390px/logo-studio-390px.avif";
import logo428 from "./logo/428px/logo-studio-428px.avif";
import logo744 from "./logo/744px/logo-studio-744px.avif";
import logo1024 from "./logo/1024px/logo-studio-1024px.avif";
import logo1440 from "./logo/1440px/logo-studio-1440px.avif";

export const useLogoStudioHook = () => {
  const [picture, setPicture] = useState("");

  useEffect(() => {
    const updatePicture = () => {
      const width = window.innerWidth;
      let selectedPicture;

      if (width < 391) {
        selectedPicture = logo390;
      } else if (width < 428) {
        selectedPicture = logo428;
      } else if (width < 744) {
        selectedPicture = logo744;
      } else if (width < 1025) {
        selectedPicture = logo1024;
      } else {
        selectedPicture = logo1440;
      }

      setPicture(selectedPicture);
    };

    updatePicture();

    window.addEventListener("resize", updatePicture);
    return () => {
      window.removeEventListener("resize", updatePicture);
    };
  }, []);

  return picture;
};
